/** How many panels can be selected at once. */
export enum SelectionPanelGroupSelectionType {
    /** One at a time; clicking another panel moves the selection (the default). */
    Single = 'single',
    /** Any number (up to maxSelection, when set); clicking a selected panel deselects it. */
    Multiple = 'multiple',
}
